export default __webpack_public_path__ + "static/media/PurchaseLinkIndicatorDeliveryActive.f7c8dc8f.svg";